const PARTICLES = new Set(["de", "da", "do", "das", "dos", "e"]);

/**
 * Formata nome para crachá:
 * 1º e 2º nomes + último por extenso; demais abreviados (exceto partículas).
 * Ex.: "José Carlos Alberto da Silva" → "José Carlos A. da Silva"
 */
export function formatBadgeName(fullName: string): string {
  const parts = fullName
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (parts.length <= 3) {
    return parts.join(" ");
  }

  const first = parts[0];
  const second = parts[1];
  const last = parts[parts.length - 1];
  const middle = parts.slice(2, -1).map((part) => {
    if (PARTICLES.has(part.toLowerCase())) {
      return part.toLowerCase();
    }
    return `${part.charAt(0).toUpperCase()}.`;
  });

  return [first, second, ...middle, last].join(" ");
}
